import { NavLink, Outlet } from "react-router-dom";
import { User, Receipt, CreditCard, LifeBuoy, Globe } from "lucide-react";

const SECTIONS = [
    { to: "/app/account", icon: User, label: "Profil", testId: "settings-nav-profile" },
    { to: "/app/forfait", icon: CreditCard, label: "Forfait", testId: "settings-nav-forfait" },
    { to: "/app/invoices", icon: Receipt, label: "Factures", testId: "settings-nav-invoices" },
    { to: "/app/aide", icon: LifeBuoy, label: "Aide", testId: "settings-nav-help" },
];

/**
 * Emergent-style settings layout: left sidebar with sections + main content area.
 * Used by /app/account, /app/forfait, /app/invoices, /app/aide.
 */
export default function SettingsLayout() {
    return (
        <div className="max-w-6xl mx-auto px-6 sm:px-8" data-testid="settings-layout">
            <div className="mb-10 tk-rise">
                <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#86868B]">Mon compte</p>
                <h1 className="mt-2 text-3xl sm:text-4xl font-semibold tracking-tight text-[#1D1D1F]">
                    Paramètres
                </h1>
            </div>

            <div className="grid lg:grid-cols-[220px_1fr] gap-10">
                {/* Sidebar */}
                <aside>
                    <nav className="tk-card p-2 sticky top-24 tk-rise tk-rise-1">
                        {SECTIONS.map((s) => (
                            <NavLink
                                key={s.to}
                                to={s.to}
                                data-testid={s.testId}
                                className={({ isActive }) =>
                                    `flex items-center gap-3 px-4 py-3 rounded-xl text-sm transition ${
                                        isActive
                                            ? "bg-[#1D1D1F] text-white"
                                            : "text-[#1D1D1F] hover:bg-[#F5F5F7]"
                                    }`
                                }
                            >
                                <s.icon className="w-4 h-4" />
                                <span>{s.label}</span>
                            </NavLink>
                        ))}
                    </nav>
                </aside>

                {/* Content */}
                <div className="min-w-0 tk-rise tk-rise-2">
                    <Outlet />
                </div>
            </div>
        </div>
    );
}
